export const stepEducation = {
  "Feed Starter": {
    tip: "Feed your starter with equal parts flour and water. A healthy starter should double in size within 4-6 hours and have a pleasant, tangy aroma.",
    keyPoints: [
      "Use room temperature water",
      "Choose unbleached flour",
      "Look for bubbles and a sour smell",
    ],
  },
  "Mix Dough": {
    tip: "Combine flour and water (but not salt yet) until no dry flour remains. The dough will look shaggy at this stage.",
    keyPoints: [
      "Use water at 90-95°F for optimal enzyme activity",
      "Mix just until incorporated",
      "Cover to prevent drying",
    ],
  },
  "Autolyse (Rest Dough)": {
    tip: "This rest period allows flour to fully hydrate and begins gluten development without kneading. The dough will become more extensible.",
    keyPoints: [
      "Keep dough covered",
      "Maintain room temperature",
      "No stretching needed during this time",
    ],
  },
  "Add Salt & Stretch-Folds": {
    tip: "Salt controls fermentation rate and strengthens gluten. Stretch-folds develop the dough structure without heavy kneading.",
    keyPoints: [
      "Perform 4-6 stretch-folds",
      "Wait 15-30 minutes between folds",
      "Dough should become smoother and stronger",
    ],
  },
  "Bulk Fermentation": {
    tip: "The main fermentation period where the dough develops flavor and strength. Look for 30-50% volume increase and small bubbles on the surface.",
    keyPoints: [
      "Keep at consistent temperature",
      "Dough should feel lighter and airier",
      "Surface should become domed",
    ],
  },
  "Pre-Shape Dough": {
    tip: "Gently shape into a rough ball to begin organizing the dough's structure. This helps create surface tension for the final shape.",
    keyPoints: [
      "Use light flour on surface",
      "Handle dough gently to keep air",
      "Create slight surface tension",
    ],
  },
  "Bench Rest": {
    tip: "This relaxation period makes final shaping easier by letting the gluten relax. The dough should spread slightly but maintain some height.",
    keyPoints: [
      "Cover to prevent drying",
      "Dough should relax but not flatten",
      "Surface should remain tacky",
    ],
  },
  "Final Shaping": {
    tip: "Create tension in the dough surface while preserving the gas bubbles inside. The shape you create now determines your final loaf.",
    keyPoints: [
      "Work quickly but gently",
      "Maintain surface tension",
      "Seal seams well",
    ],
  },
  "Cold Proof (Refrigeration)": {
    tip: "Slow fermentation in the fridge develops complex flavors and makes scoring easier. The dough should pass the poke test before baking.",
    keyPoints: [
      "Keep covered to prevent drying",
      "Longer proof = more sour flavor",
      "Look for slight surface bubbles",
    ],
  },
  "Preheat Oven": {
    tip: "A properly preheated oven and stone/Dutch oven ensures good oven spring. The high initial heat helps create a beautiful crust.",
    keyPoints: [
      "Preheat Dutch oven if using",
      "Add water tray for steam",
      "Verify temperature with thermometer",
    ],
  },
  "Bake Bread": {
    tip: "Steam in the first part of baking allows for maximum oven spring. Remove the lid (if using Dutch oven) halfway through for crust development.",
    keyPoints: [
      "Score bread just before baking",
      "Create steam for first 20-25 mins",
      "Look for deep golden brown color",
    ],
  },
  "Rest & Cool": {
    tip: "Letting the bread cool completely sets the crumb structure and prevents gumminess. Listen for crackling crust (the 'bread song').",
    keyPoints: [
      "Wait at least 1 hour",
      "Listen for crackling sounds",
      "Cut when completely cool",
    ],
  },
};
